import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
import ContextProvider from 'common/contexts/crud';

const CallContext = createContext();

export const CallsProvider = ({ children }) => (
  <ContextProvider url="calls" context={CallContext}>{children}</ContextProvider>
);

CallsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const useCall = () => useContext(CallContext);

export default useCall;
